import React, { useState, useEffect } from 'react';
import { Form, Button, Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { addState, setLoading, setStates, setError, updateState } from '../../../core/data/redux/stateDistrictSlice';
import { fetchStates, addState as addStateService, updateState as updateStateService } from '../../../core/data/services/stateDistrictBlockService';
import { State } from '../../../core/data/types/stateDistrict';

interface StateFormProps {
  show: boolean;
  onHide: () => void;
  state?: State; // Optional for editing
}

const StateForm: React.FC<StateFormProps> = ({ show, onHide, state }) => {
  const dispatch = useDispatch();
  const [name, setName] = useState(state?.name || '');
  const [code, setCode] = useState(state?.code || '');

  useEffect(() => {
    if (state) {
      setName(state.name);
      setCode(state.code || '');
    }
  }, [state]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      dispatch(setLoading(true));

      // Validate inputs
      if (!name || !code) {
        throw new Error("Name and code are required");
      }

      if (state) {
        // Update existing state
        if (!state.id) {
          throw new Error("State ID is missing");
        }
        const updatedState = { id: state.id, name, code };
        console.log("Updating state with data:", updatedState);
        const response = await updateStateService(updatedState);
        dispatch(updateState(response))
        console.log("Update response:", response);
      } else {
        // Add new state
        const response = await addStateService({ name, code });
        console.log("Add state response:", response);
        dispatch(addState(response));
      }

      // Re-fetch states to ensure UI is updated
      const states = await fetchStates();
      console.log("Fetched states:", states);
      dispatch(setStates(states));
      setName('')
      onHide();  // Close modal or form
    } catch (err: any) {
      console.error("Error in handleSubmit:", err);
      dispatch(setError(err.message || "Failed to save state"));
    } finally {
      dispatch(setLoading(false)); // Ensure loading is reset
      setName('')

    }
  };


  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>{state ? 'Edit State' : 'Add State'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>State Name</Form.Label>
            <Form.Control
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>State Code</Form.Label>
            <Form.Control
              type="text"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              required
            />
          </Form.Group>
          <Button variant="primary" type="submit">
            {state ? 'Update' : 'Add'} State
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default StateForm;